// extracted by mini-css-extract-plugin
export default {"container":"SWInput_container__nGrO0","editable":"SWInput_editable__w65hp","displayText":"SWInput_displayText__HA6gF","input":"SWInput_input__SRMr7","label":"SWInput_label__S2Hv2"};